/* eslint-disable react/react-in-jsx-scope */
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import '../styles/iransans.css'
import '../styles/utilities.css'
import '../styles/libs/flaticon.css'
import '../styles/variable.css'
import '../styles/globals.css'

import { useRef, memo, useEffect } from 'react'
import { CartProvider } from '../components/front/Cart'
import { UserProvider } from '../components/front/User'
import { useRouter } from 'next/router'

const Noop = ({ children }) => <>{children}</>
const ROUTES_TO_RETAIN = [/\/products/]

function MyApp({ Component, pageProps }) {
    const Layout = Component.Layout || Noop
    const router = useRouter()
    const retainedComponents = useRef({})

    let isRetainableRoute = false

    for (const pat of ROUTES_TO_RETAIN) {
        if (pat.test(router.asPath)) isRetainableRoute = true
    }
    // Add Component to retainedComponents if we haven't got it already
    if (isRetainableRoute && !retainedComponents.current[router.asPath]) {
        const MemoComponent = memo(Component)
        retainedComponents.current[router.asPath] = {
            component: <MemoComponent {...pageProps} />,
            scrollPos: 0
        }
    }
    // Save the scroll position of current page before leaving
    const handleRouteChangeStart = () => {
        if (isRetainableRoute) {
            retainedComponents.current[router.asPath].scrollPos = window.scrollY
        }
    }

    // Save scroll position - requires an up-to-date router.asPath
    useEffect(() => {
        router.events.on('routeChangeStart', handleRouteChangeStart)
        return () => {
            router.events.off('routeChangeStart', handleRouteChangeStart)
        }
    }, [router.asPath])

    // Scroll to the saved position when we load a retained component
    useEffect(() => {
        if (isRetainableRoute) {
            window.scrollTo(0, retainedComponents.current[router.asPath].scrollPos)
        }
    }, [Component, pageProps])

    return (
        <UserProvider>
            <CartProvider>
                <Layout pageProps={pageProps}>
                    <div style={{ display: isRetainableRoute ? 'block' : 'none' }}>
                        {Object.entries(retainedComponents.current).map(([path, c]) => (
                            <div key={path} style={{ display: router.asPath === path ? 'block' : 'none' }}>
                                {c.component}
                            </div>
                        ))}
                    </div>
                    {!isRetainableRoute && <Component {...pageProps} />}
                </Layout>
            </CartProvider>
        </UserProvider>
    )
}

export default MyApp
